module.exports = __webpack_public_path__ + "img/mbr-bg.0dd40db1.svg";